import React from 'react';
import {useTaopix} from '../Context/TaopixContext';
import Photobook from './Photobook/Photobook';
import {AppMenuItem} from '../AppMenu/AppMenu';
import GreetingCard from './GreetingCard/GreetingCard';
import {useExperience} from '../Experience/ExperienceProvider';

export type EditorFactoryProps = {
  onClickMenuItem: (item: AppMenuItem) => void;
};

const EditorFactory = (props: EditorFactoryProps) => {
  const app = useTaopix();
  const {experience} = useExperience();

  // if the app has not loaded, do nothing
  if (!app.state.loaded) {
    return <></>;
  }

  // use the Greeting Card editor if required
  if (experience.EDITOR.editorType.useGreetingCardEditor) {
    return <GreetingCard {...props} />;
  }

  // otherwise use the photobook editor
  return <Photobook {...props} />;
};

export default EditorFactory;
